import { dialog } from '@/plugins/dialog';
import * as Locale from '@/plugins/i18n';
import { waitFor } from './utils';
import { noop } from 'vue-class-component/lib/util';

export const waitDialog = async <T = void>({ promise, timeout }: { promise: Promise<T>; timeout?: number }) => {
  const waitDialog = dialog({
    content: Locale.i18n.t('global.please_wait') as string,
  });

  await Promise.race([
    promise,
    ...(timeout
      ? [
          waitFor(timeout).then(() => {
            throw new Error('Wait dialog timeout');
          }),
        ]
      : []),
  ]).catch(noop);

  waitDialog.close();
};
